<template>
  <div class="container-fluid py-4">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-7">

        <div class="card ficha-listado">
          <div class="px-4 pb-4 card-body">

            <!-- Cabecera -->
            <div class="mb-4">
              <h6 class="mb-0 panel-section-title">Países de venta</h6>
              <p class="text-xs opacity-7 mb-0">
                Lista de países disponibles en el selector de compra de /pronostico.
                Los cambios se aplican de inmediato.
              </p>
            </div>

            <!-- Añadir país -->
            <div class="add-row mb-4">
              <div class="d-flex gap-2 align-items-center flex-wrap">
                <input
                  v-model="nuevoCodigo"
                  type="text"
                  class="form-control form-control-sm"
                  style="max-width:100px; text-transform:uppercase;"
                  placeholder="Ej: GT"
                  maxlength="2"
                  @keyup.enter="addPais"
                  :disabled="guardando"
                />
                <button class="btn btn-sm btn-primary" @click="addPais" :disabled="guardando || !nuevoCodigo.trim()">
                  <span v-if="guardando" class="pi pi-spin pi-spinner me-1"></span>
                  Añadir país
                </button>
                <span v-if="errorAdd" class="text-danger text-xs">{{ errorAdd }}</span>
                <span v-if="okAdd" class="text-success text-xs">{{ okAdd }}</span>
              </div>
              <small class="text-muted d-block mt-1" style="font-size:0.75rem;">
                Código ISO 3166-1 alfa-2 en mayúsculas (2 letras). El nombre se muestra si está en el sistema de traducciones.
              </small>
            </div>

            <!-- Lista de países activos -->
            <div v-if="cargando" class="text-center py-4 opacity-5">Cargando...</div>
            <div v-else>
              <div class="pais-grid">
                <div
                  v-for="codigo in paises"
                  :key="codigo"
                  class="pais-chip"
                >
                  <span class="pais-chip__nombre">{{ nombrePais(codigo) }}</span>
                  <span class="pais-chip__codigo">{{ codigo }}</span>
                  <button
                    class="pais-chip__del"
                    title="Eliminar"
                    @click="deletePais(codigo)"
                    :disabled="eliminando === codigo"
                  >
                    <span v-if="eliminando === codigo" class="pi pi-spin pi-spinner" style="font-size:10px;"></span>
                    <span v-else>×</span>
                  </button>
                </div>
              </div>
              <p v-if="!paises.length" class="text-muted text-xs text-center py-3">
                No hay países configurados.
              </p>
              <p class="text-xs opacity-5 mt-3 mb-0">{{ paises.length }} países activos</p>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + "/api/v2/";

const NOMBRES = {
  ES:"España", FR:"Francia", PT:"Portugal", DE:"Alemania", IT:"Italia",
  NL:"Países Bajos", BE:"Bélgica", IE:"Irlanda", GB:"Reino Unido", CH:"Suiza",
  AT:"Austria", SE:"Suecia", NO:"Noruega", DK:"Dinamarca", FI:"Finlandia",
  PL:"Polonia", MX:"México", AR:"Argentina", CL:"Chile", CO:"Colombia",
  PE:"Perú", EC:"Ecuador", UY:"Uruguay", PY:"Paraguay", BO:"Bolivia",
  VE:"Venezuela", BR:"Brasil", US:"Estados Unidos", CA:"Canadá",
  SV:"El Salvador", GT:"Guatemala", HN:"Honduras", NI:"Nicaragua",
  CR:"Costa Rica", PA:"Panamá", DO:"Rep. Dominicana", CU:"Cuba",
  PR:"Puerto Rico", AU:"Australia",
};

export default {
  name: "PaisesVenta",
  data() {
    return {
      paises:      [],
      cargando:    true,
      nuevoCodigo: "",
      guardando:   false,
      eliminando:  null,
      errorAdd:    "",
      okAdd:       "",
    };
  },
  mounted() {
    this.cargar();
  },
  methods: {
    nombrePais(codigo) {
      if (NOMBRES[codigo]) return NOMBRES[codigo];
      try {
        const names = new Intl.DisplayNames(['es'], { type: 'region' });
        return names.of(codigo) || codigo;
      } catch (_) { return codigo; }
    },
    async cargar() {
      this.cargando = true;
      try {
        const { data } = await api.get(API_URL + "paises-venta");
        this.paises = data.paises;
      } finally {
        this.cargando = false;
      }
    },
    async addPais() {
      const codigo = this.nuevoCodigo.trim().toUpperCase();
      if (!codigo || codigo.length !== 2) {
        this.errorAdd = "El código debe tener exactamente 2 letras.";
        return;
      }
      this.errorAdd = "";
      this.okAdd = "";
      this.guardando = true;
      try {
        await api.post(API_URL + "paises-venta", { codigo });
        this.nuevoCodigo = "";
        this.okAdd = `${codigo} añadido.`;
        await this.cargar();
        setTimeout(() => { this.okAdd = ""; }, 3000);
      } catch (e) {
        this.errorAdd = e.response?.data?.message || "Error al añadir el país.";
      } finally {
        this.guardando = false;
      }
    },
    async deletePais(codigo) {
      if (!confirm(`¿Eliminar ${this.nombrePais(codigo)} (${codigo}) de la lista de venta?`)) return;
      this.eliminando = codigo;
      try {
        await api.delete(API_URL + "paises-venta/" + codigo);
        await this.cargar();
      } catch (e) {
        alert(e.response?.data?.message || "Error al eliminar el país.");
      } finally {
        this.eliminando = null;
      }
    },
  },
};
</script>

<style scoped>
.pais-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pais-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-radius: 20px;
  padding: 4px 10px 4px 12px;
  font-size: 13px;
}

.pais-chip__nombre {
  color: var(--q-text);
  font-weight: 500;
}

.pais-chip__codigo {
  font-size: 10px;
  color: var(--q-muted);
  font-weight: 700;
  letter-spacing: .5px;
}

.pais-chip__del {
  background: none;
  border: none;
  color: var(--q-muted);
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  padding: 0 2px;
  transition: color .15s;
}
.pais-chip__del:hover:not(:disabled) {
  color: #dc3545;
}
.pais-chip__del:disabled {
  opacity: .5;
}

.add-row {
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-radius: 12px;
  padding: 14px 16px;
}
</style>
